export default function CalculatorStyle() {
    return `
    form button,
    form label {
      width: 380px;
      justify-content: center;
    }
    .split50 {
      width: 380px;
    }
    .input-container {
      max-width: 48%;
    }
    form .split50 label,
    form .split50 input{
      max-width: 100%;
    }
    .poppins-font {
      font-family: "Poppins", sans-serif;
    }
    .calculator-text {
      font-family: "Poppins", sans-serif;
      font-size: 16px;
      line-height: 1.3;
      color: #1A1A1A;
    }
    .calculator-button-text {
      font-family: "Poppins", sans-serif;
      font-size: 16px;
      line-height: 1.3;
      color: #1A1A1A;
    }
    #business-type span {
      height: 22px;
    }

    @media screen and (max-width: 500px) {
      form button,
      form label {
        width: 300px;
        justify-content: center;
      }
      .split50 {
        width: 300px;
      }
      .calculator-text {
        font-size: 14px;
      }
      .calculator-button-text {
        font-size: 14px;
      }
    }

    @media screen and (min-width: 540px) {
      .step-shadow {
        background-color: white;
        box-shadow: 
          0px 0.796192px 2.38858px -0.625px rgba(0, 0, 0, 0.05),
          0px 2.41451px 7.24352px -1.25px rgba(0, 0, 0, 0.05),
          0px 6.38265px 19.148px -1.875px rgba(0, 0, 0, 0.05),
          0px 20px 60px -2.5px rgba(0, 0, 0, 0.05);
      }
    }

    #client-calculator .step1 select {
      z-index: 500;
    }

    @theme inline {
      --breakpoint-3xl: 67.375rem;
      --breakpoint-esm: 33.75rem; /* 540 px */
      --radius-sm: calc(var(--radius) - 4px);
      --radius-md: calc(var(--radius) - 2px);
      --radius-lg: var(--radius);
      --radius-xl: calc(var(--radius) + 4px);
      --color-background: var(--background);
      --color-foreground: var(--foreground);
      --color-card: var(--card);
      --color-card-foreground: var(--card-foreground);
      --color-popover: var(--popover);
      --color-popover-foreground: var(--popover-foreground);
      --color-primary: var(--primary);
      --color-primary-foreground: var(--primary-foreground);
      --color-secondary: var(--secondary);
      --color-secondary-foreground: var(--secondary-foreground);
      --color-muted: var(--muted);
      --color-muted-foreground: var(--muted-foreground);
      --color-accent: var(--accent);
      --color-accent-foreground: var(--accent-foreground);
      --color-destructive: var(--destructive);
      --color-border: var(--border);
      --color-input: var(--input);
      --color-ring: var(--ring);
      --color-chart-1: var(--chart-1);
      --color-chart-2: var(--chart-2);
      --color-chart-3: var(--chart-3);
      --color-chart-4: var(--chart-4);
      --color-chart-5: var(--chart-5);
      --color-sidebar: var(--sidebar);
      --color-sidebar-foreground: var(--sidebar-foreground);
      --color-sidebar-primary: var(--sidebar-primary);
      --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
      --color-sidebar-accent: var(--sidebar-accent);
      --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);
      --color-sidebar-border: var(--sidebar-border);
      --color-sidebar-ring: var(--sidebar-ring);
    }

    :root {
      --radius: 0.625rem !important;
      --background: #ffffff !important;
      --foreground: #272727 !important;
      --card: #ffffff !important;
      --card-foreground: #272727 !important;
      --popover: #ffffff !important;
      --popover-foreground: #272727 !important;
      --primary: #f7ce2a !important;
      --primary-foreground: #000000 !important;
      --secondary: #f8f8f8 !important;
      --secondary-foreground: #bfa100 !important;
      --muted: #f8f8f8 !important;
      --muted-foreground: #8e8e8e !important;
      --accent: #f8f8f8 !important;
      --accent-foreground: #000000 !important;
      --destructive: #e07a5f !important;
      --border: #ebebeb !important;
      --input: #ebebeb !important;
      --ring: #b5b5b5 !important;
      --chart-1: #b7a13a !important;
      --chart-2: #7ea7d8 !important;
      --chart-3: #4d5d9a !important;
      --chart-4: #e6e05a !important;
      --chart-5: #e2d34d !important;
      --sidebar: #fcfcfc !important;
      --sidebar-foreground: #272727 !important;
      --sidebar-primary: #bfa100 !important;
      --sidebar-primary-foreground: #fcfcfc !important;
      --sidebar-accent: #f8f8f8 !important;
      --sidebar-accent-foreground: #bfa100 !important;
      --sidebar-border: #ebebeb !important;
      --sidebar-ring: #b5b5b5 !important;
    }
    `;
}
